import Vue from 'vue'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN_ZL_ONE, ACCESS_NAME, ACCESS_AVATAR } from '@/store/mutation-types'
//ACCESS_ID
import { welcome } from '@/utils/util'
import { asyncRouterMap } from '@/config/router.config'
const user = {
  state: {
    token: '',
    name: '',  
    id: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_ID: (state, { id }) => {
      state.id = id
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          console.log(response)
          Vue.ls.set(ACCESS_TOKEN_ZL_ONE, response.token, 2 * 24 * 60 * 60 * 1000)
          Vue.ls.set(ACCESS_NAME, response.admin.username, 2 * 24 * 60 * 60 * 1000)
          Vue.ls.set(ACCESS_AVATAR, "http://b-ssl.duitang.com/uploads/item/201811/04/20181104203324_xfeme.thumb.700_0.jpg", 2 * 24 * 60 * 60 * 1000)
          commit('SET_TOKEN', response.token)
          commit('SET_NAME', { name: response.admin.username, welcome: welcome() })
          commit('SET_AVATAR', "http://b-ssl.duitang.com/uploads/item/201811/04/20181104203324_xfeme.thumb.700_0.jpg")
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const result = response.result
          if (result.role && result.role.permissions.length > 0) {
            const role = result.role
            role.permissions = result.role.permissions
            role.permissions.map(per => {
              if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
                const action = per.actionEntitySet.map(action => {
                  return action.action
                })
                per.actionList = action
              }
            })
            role.permissionList = role.permissions.map(permission => {
              return permission.permissionId
            })
            commit('SET_ROLES', result.role)
            commit('SET_INFO', result)
          } else {
            reject(new Error('getInfo: roles must be a non-null array !'))
          }

          commit('SET_NAME', { name: result.name, welcome: welcome() })
          commit('SET_ID', { name: result.name, welcome: welcome() })
          commit('SET_AVATAR', result.avatar)

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        Vue.ls.remove(ACCESS_TOKEN_ZL_ONE)
        resolve()
      })
    },
    setInfo({ commit }) {
      return new Promise((resolve) => {
        if (Vue.ls.get(ACCESS_TOKEN_ZL_ONE)) {
          commit('SET_NAME', { name: Vue.ls.get(ACCESS_NAME), welcome: welcome() })
          // commit('SET_ID', { id: Vue.ls.get(ACCESS_ID) })
          commit('SET_AVATAR', Vue.ls.get(ACCESS_AVATAR))
        }
        resolve()
      })
    }
  }
}

export default user
